import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';
import { AgentClientApplication, InlineClientApplication } from '../api/agentStep.model';
import {
  getClientApplicationIconPath,
  getClientApplicationDisplayName,
  getInlineClientApplicationDisplayName,
  getInlineClientApplicationLogoPath,
  getInlineClientApplicationBackendValues,
} from 'src/app/common/aiServiceUtils';

/**
 * AIDR (Audit Log) mode client application select options
 * Uses AgentClientApplication enum values with unified FilterTypesEnum.ClientApplication
 */
export const aidrClientApplicationSelectOptions: ISelectOption[] = Object.values(AgentClientApplication)
  .map((clientApplication) => ({
    id: `${FilterTypesEnum.ClientApplication}-${clientApplication}`,
    value: clientApplication,
    displayName: getClientApplicationDisplayName(clientApplication),
    withoutBeautifyDisplayName: true,
    filterType: FilterTypesEnum.ClientApplication,
    categoryName: FilterTypesEnum.ClientApplication.toString(),
    iconPath: getClientApplicationIconPath(clientApplication),
  }))
  .sort((a, b) => a.displayName.localeCompare(b.displayName));

/**
 * Inline mode client application select options
 * Uses InlineClientApplication enum values with unified FilterTypesEnum.ClientApplication
 */
export const inlineUnifiedClientApplicationSelectOptions: ISelectOption[] = Object.values(InlineClientApplication)
  .map((clientApplication) => ({
    id: `${FilterTypesEnum.ClientApplication}-${clientApplication}`,
    value: getInlineClientApplicationBackendValues(clientApplication).join(','),
    displayName: getInlineClientApplicationDisplayName(clientApplication),
    withoutBeautifyDisplayName: true,
    filterType: FilterTypesEnum.ClientApplication,
    categoryName: FilterTypesEnum.ClientApplication.toString(),
    iconPath: getInlineClientApplicationLogoPath(clientApplication),
  }))
  .sort((a, b) => a.displayName.localeCompare(b.displayName));
